export default "__VITE_ASSET__c61a4e77__"